<script lang="ts">

	import { removeCookie, setCookie } from '$services/CookieService';
	import { onMount } from 'svelte';
	import type { TestUser } from '../../domain/TestUser';

	export let testUsers: TestUser[];

	const defaultCustomerId = 'basicCustomerId';

	let selectedUser: string;
	let app: string;

	const appValues = [{displayName: "desktop", value: ""}, {displayName: "app", value: "app"}]

	onMount(() => {
		selectedUser = localStorage.getItem('testUserType') || defaultCustomerId;
		app = localStorage.getItem('isApp') || appValues[0].value
	});

	const onTestingUserChange = () => {
		const owt = testUsers.find(testUser => testUser.customerId === selectedUser)!.owt;
		setCookie('owt', owt);
		localStorage.setItem('testUserType', selectedUser);
		window.location.reload();
	};
	const onAppCookieChange = () => {
		if(app != "") {
			setCookie('app', 'true');
		} else {
			removeCookie('app')
		}
		localStorage.setItem('isApp', app);
		window.location.reload();
	};

</script>

<div class="pl_dropdown pl_m100">
	Testing user:
	<select bind:value={selectedUser} class="js-pl_dropdown__element pl_dropdown__element" id="dropdown"
		on:change={onTestingUserChange}>
		{#each testUsers as testUser}
			<option value={testUser.customerId}>{testUser.displayName}</option>
		{/each}
	</select>
	<label class="js-pl_label pl_label" for="dropdown">Select user:</label>
</div>

<div class="pl_dropdown pl_m100">
	App or desktop:
	<select bind:value={app} class="js-pl_dropdown__element pl_dropdown__element" id="dropdown"
		on:change={onAppCookieChange}>
		{#each appValues as appValue}
			<option value={appValue.value}>{appValue.displayName}</option>
		{/each}
	</select>
	<label class="js-pl_label pl_label" for="dropdown">Select user:</label>
</div>
